export default __webpack_public_path__ + "static/media/pgmico(22).c9cd72c1.png";